// About.js - with Tailwind CSS
import React from "react";

const About = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12 bg-gradient-to-br from-white to-orange-50">
      
      {/* Hero Section */}
      <div className="text-center bg-gradient-to-br from-orange-100 via-amber-50 to-orange-100 rounded-[4rem] rounded-br-[2rem] rounded-tl-[2rem] p-8 md:p-12 mb-12 shadow-xl">
        <h1 className="text-4xl md:text-6xl font-extrabold text-orange-800 mb-3 tracking-tight">
          Hr Bachat Bazar
        </h1>
        <p className="text-xl md:text-2xl text-amber-900 font-semibold mb-4">
          Your Trusted Partner for a Cleaner, Brighter Home
        </p>
        <div className="inline-block bg-white px-6 py-3 rounded-full shadow-md">
          <p className="text-lg md:text-2xl font-bold text-emerald-800">
            “Sasta Nahi, <span className="text-orange-600 bg-orange-50 px-2 rounded-lg">Sahi</span> – Kyunki Har Bachat Me Dum Ho”
          </p>
        </div>
      </div>

      {/* Main Story Section */}
      <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-lg p-6 md:p-10 mb-16 border border-orange-100">
        <h2 className="text-2xl md:text-3xl font-bold text-orange-700 mb-4 text-center">
          From Local Kirana to Your Doorstep
        </h2>
        <div className="space-y-4 text-gray-700 text-base md:text-lg leading-relaxed">
          <p>
            At <span className="font-bold text-orange-600">Hr Bachat Bazar</span>, we believe that <span className="font-semibold">quality washing powder</span> should never burn a hole in your pocket. 
            That's why we bring you <span className="font-bold text-emerald-700">HR Excel Washing Powder</span> – a powerful, stain-fighting formula trusted by thousands of families 
            across India. Now available online with <span className="font-semibold">free delivery, bulk discounts, and zero hassle</span>.
          </p>
          <p>
            "Bachat" is in our name, and "Bharosa" is in our product. HR Excel delivers <span className="font-semibold">3X more stain removal</span>, works in <span className="font-semibold">hard water</span>, 
            and keeps your whites sparkling – exactly what Indian homes need. No fancy ads, just <span className="font-semibold text-orange-600">honest value</span>.
          </p>
        </div>
      </div>

      {/* Why Choose Us - Benefits Grid */}
      <div className="mb-16">
        <h2 className="text-2xl md:text-4xl font-bold text-center text-gray-800 mb-3">
          Why Hr Bachat Bazar <span className="text-orange-500 text-3xl md:text-5xl">+</span> HR Excel?
        </h2>
        <p className="text-center text-gray-600 mb-10">Because your family deserves the best at the best price</p>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Card 1 */}
          <div className="bg-white rounded-2xl p-6 text-center shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-b-4 border-orange-300 hover:border-orange-500">
            <div className="text-5xl mb-3">🏷️</div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">Maximum Bachat</h3>
            <p className="text-gray-600 text-sm">Up to 30% lower than market price – direct from stockists to you.</p>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-2xl p-6 text-center shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-b-4 border-orange-300 hover:border-orange-500">
            <div className="text-5xl mb-3">🧺</div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">Factory-Fresh HR Excel</h3>
            <p className="text-gray-600 text-sm">Authentic, sealed packs with extended shelf life. No dust, no lumps.</p>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-2xl p-6 text-center shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-b-4 border-orange-300 hover:border-orange-500">
            <div className="text-5xl mb-3">🚚</div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">Free Home Delivery</h3>
            <p className="text-gray-600 text-sm">on orders above ₹499 – same-day dispatch in most cities.</p>
          </div>

          {/* Card 4 */}
          <div className="bg-white rounded-2xl p-6 text-center shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-b-4 border-orange-300 hover:border-orange-500">
            <div className="text-5xl mb-3">💯</div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">Love It or Get Refund</h3>
            <p className="text-gray-600 text-sm">No questions asked return policy – because we trust our powder.</p>
          </div>
        </div>
      </div>

      {/* Promise Section */}
      <div className="bg-emerald-900 rounded-[3rem] rounded-br-[1rem] rounded-tl-[1rem] p-8 md:p-12 mb-16">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-amber-100 text-xl md:text-2xl font-medium leading-relaxed">
            “We don't sell just detergent – we sell <span className="text-amber-300 font-bold">peace of mind, affordability, and spotless clothes</span> for your entire family.”
          </p>
          <p className="text-amber-200 mt-6 text-base opacity-80">
            – Team Hr Bachat Bazar
          </p>
        </div>
      </div>

      {/* Stats/Social Proof Section */}
      <div className="bg-gradient-to-r from-orange-500 to-amber-600 rounded-2xl p-8 mb-16 text-white">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div>
            <div className="text-3xl md:text-4xl font-bold">50,000+</div>
            <div className="text-sm mt-2 opacity-90">Happy Families</div>
          </div>
          <div>
            <div className="text-3xl md:text-4xl font-bold">30%</div>
            <div className="text-sm mt-2 opacity-90">Average Savings</div>
          </div>
          <div>
            <div className="text-3xl md:text-4xl font-bold">4.9⭐</div>
            <div className="text-sm mt-2 opacity-90">Customer Rating</div>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="bg-gradient-to-br from-orange-100 via-amber-50 to-orange-100 rounded-3xl p-8 md:p-12 text-center shadow-xl">
        <h3 className="text-2xl md:text-4xl font-bold text-orange-800 mb-3">
          Ready to switch to smarter washing?
        </h3>
        <p className="text-gray-700 text-base md:text-lg mb-6">
          Join 50,000+ happy households who saved money without compromising on clean.
        </p>
        <button 
          onClick={() => window.location.href = '/'} 
          className="bg-orange-600 hover:bg-orange-700 text-white font-bold py-3 px-8 rounded-full text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
        >
          Shop HR Excel Washing Powder →
        </button>
        <p className="text-xs text-gray-500 mt-4">✓ Free Shipping ✓ Secure Payment ✓ Cash on Delivery</p>
      </div>

      {/* Trust Badges */}
      <div className="mt-8 flex flex-wrap justify-center gap-4 text-xs text-gray-500">
        <span className="flex items-center gap-1">✅ 100% Authentic Products</span>
        <span className="flex items-center gap-1">⭐ 4.9/5 Customer Rating</span>
        <span className="flex items-center gap-1">🛡️ Secure Checkout</span>
        <span className="flex items-center gap-1">🚚 Fast Shipping</span>
      </div>
    </div>
  );
};

export default About;